import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DataTable from "react-data-table-component";
import authApiService from "../../services/authServices";
import { ThreeDots } from 'react-loader-spinner'
import { generateExcel } from '../../services/ExportExcelServices';
import { generatePDF } from '../../services/ExportPDF';
import { generateCSV } from '../../services/ExportExcelServices';
import Modal from "../../utils/modalUtils";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [adminUsers, setAdminUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const getUsers = async () => {
        try {
            const usersdata = await authApiService.get('users');
            const filteredUsers = usersdata.data.map(user => ({
                id: user.userId,
                username: user.username,
                fullName: user.fullName,
                email: user.email,
                isEnabled: user.account_locked === "N" ? true : false,
            }));
            setUsers(filteredUsers);
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        const getAdminUsers = async () => {
            try {
                const adminUsersdata = await authApiService.get('getUsersExcell');
                setAdminUsers(adminUsersdata.data);
            } catch (error) {
                console.error("Error fetching admin users:", error);
            } finally {
                setIsLoading(false);
            }
        };
        getAdminUsers();
    }, []);

    /**
     * Handles user deletion with confirmation
     * @param {Object} row - The user row to delete
     */
    const handleDelete = async (row) => {
        try {
            const result = await Modal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#addd1e",
                cancelButtonColor: "#b38ec1",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel"
            });

            if (result.isConfirmed) {
                try {
                    await authApiService.put(`deleteUser?id=${row.id}`);
                    Modal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "User has been deleted.",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#addd1e"
                    });
                    getUsers();
                } catch (error) {
                    console.error("Error deleting user:", error);
                    Modal.fire({
                        icon: "error",
                        title: "Error!",
                        text: error.response?.data?.message || "Failed to delete user.",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#addd1e"
                    });
                }
            }
        } catch (error) {
            console.error("Error in handleDelete:", error);
        }
    };

    const columns = [
        { name: "Username", selector: (row) => row.username, sortable: true },
        { name: "Full Name", selector: (row) => row.fullName, sortable: true },
        { name: "Email", selector: (row) => row.email, sortable: true },
        {
            name: "Enabled",
            cell: row => <input type="checkbox" checked={row.isEnabled} disabled readOnly />,
            sortable: true
        },
        {
            name: "Action",
            cell: (row) => <Link to="#" className="text-danger" onClick={(e) => { e.preventDefault(); handleDelete(row); }}>Delete</Link>
        },
    ];

    const customStyles = {
        table: {
            style: {
                border: "1px solid #ddd",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#40444d",
                color: "#ffffff",
            },
        },
        rows: {
            style: {
                "&:nth-of-type(odd)": {
                    backgroundColor: "#dedfdd",
                },
                "&:nth-of-type(even)": {
                    backgroundColor: "#ffffff",
                },
            },
        },
    };

    const buttonStyle = {
        background: "#9cb23b",
        padding: "10px 10px",
        margin: "10px 0px",
        border: "none",
        borderRadius: "25px",
        minWidth: "120px",
        color: "#fff",
        cursor: "pointer",
        textAlign: "center",
        marginRight: "20px"
    };

    const downloadSheet = (e) => {
        const excelObjectData = {
            fileName: "User List",
            reportType: "User List",
            fileType: 'xls',
            sheetName: "User List",
            firstRowMergeCells: "A1:L1",
            firstRowCellNumber: 13,
            firstRowText: "User List Report",
            firstRowExportDate: new Date(),
            headerEnglishColumns: [
                "Registered City",
                "Last Name",
                "First Name",
                "Username",
              //  "Password",
                "Email",
                "Street",
                "City",
                "State",
                "Zip Code",
                "Cell Phone",
                "Home Phone",
                "Registered Date",
                "Seasons Played	",
                "Last Season Played",
                "Home Court",
                "Other Information",
                "Deleted Membership",

            ],

        };

        console.log(users)

        const transformedData = adminUsers.map(item => [
            item.city || '',
            item.lastName || '',
            item.firstName || '',
            item.username || '',
          //  item.password || '',
            item.email || '',
            item.street || '',
            item.city || '',
            item.state || '',
            item.zipCode || '',
            item.cellPhone || '',
            item.homePhone || '',
            item.registeredDate || '',
            item.seasonsPlayed || '',
            item.lastSeasonPlayed || '',
            item.homeCourt || '',
            item.otherInformation || '',
            item.deletedMembership || '',
        ]);
        excelObjectData.excelRowData = transformedData;
        console.log(excelObjectData)

        generateExcel(excelObjectData)


    }

    const downloadcsvSheet = (e) => {
        const csvObjectData = {
            fileName: "User List",
            reportType: "User List",
            fileType: 'csv',
            sheetName: "User List",
            firstRowMergeCells: "A1:L1",
            firstRowCellNumber: 13,
            firstRowText: "User List Report",
            firstRowExportDate: new Date(),
            headerEnglishColumns: [
                "Registered City",
                "Last Name",
                "First Name",
                "Username",
               // "Password",
                "Email",
                "Street",
                "City",
                "State",
                "Zip Code",
                "Cell Phone",
                "Home Phone",
                "Registered Date",
                "Seasons Played	",
                "Last Season Played",
                "Home Court",
                "Other Information",
                "Deleted Membership",

            ],

        };

        console.log(users)

        const transformedData = adminUsers.map(item => [
            item.city || '',
            item.lastName || '',
            item.firstName || '',
            item.username || '',
          //  item.password || '',
            item.email || '',
            item.street || '',
            item.city || '',
            item.state || '',
            item.zipCode || '',
            item.cellPhone || '',
            item.homePhone || '',
            item.registeredDate || '',
            item.seasonsPlayed || '',
            item.lastSeasonPlayed || '',
            item.homeCourt || '',
            item.otherInformation || '',
            item.deletedMembership || '',
        ]);
        csvObjectData.excelRowData = transformedData;
        console.log(csvObjectData)

        generateCSV(csvObjectData)


    }


    



    const handleGeneratePdf = () => {
        const headerEnglishColumns = [
            "Registered City",
            "Last Name",
            "First Name",
            "Username",
          //  "Password",
            "Email",
            "Street",
            "City",
            "State",
            "Zip Code",
            "Cell Phone",
            "Home Phone",
            "Registered Date",
            "Seasons Played	",
            "Last Season Played",
            "Home Court",
            "Other Information",
            "Deleted Membership",

        ];

        const pdfData = adminUsers.map(item => [
            item.city || '',
            item.lastName || '',
            item.firstName || '',
            item.username || '',
          //  item.password || '',
            item.email || '',
            item.street || '',
            item.city || '',
            item.state || '',
            item.zipCode || '',
            item.cellPhone || '',
            item.homePhone || '',
            item.registeredDate || '',
            item.seasonsPlayed || '',
            item.lastSeasonPlayed || '',
            item.homeCourt || '',
            item.otherInformation || '',
            item.deletedMembership || ''
        ]);

        const PDFFileName = "UserData"

        const pdfObjectData = {
            headerEnglishColumns,
            pdfData,
            width: [60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60],
            PDFFileName
        };

        generatePDF(pdfObjectData)
    }


    return (
        <div id="page-admin-users" className="page-admin mb-5">

            <DataTable
                columns={columns}
                data={users} // Use the filtered users data
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
            />

            {isLoading && <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: "flex", justifyContent: "center" }}
                wrapperClass=""
            />
            }
            <div className="exportlinks">
                Export options:
                <Link onClick={downloadcsvSheet}><span className="export csv px-2">CSV </span></Link>|
                <Link onClick={downloadSheet}><span className="export excel px-2">Excel </span></Link>|
                {/* <Link to="?d-149542-e=3&6578706f7274=1"><span className="export xml">XML </span></Link>| */}
                <Link onClick={handleGeneratePdf}><span className="export pdf pl-2">PDF </span></Link>
            </div>
            <p>
                <button style={buttonStyle} onClick={() => navigate('/carter/home')}>
                    Done
                </button>
            </p>

        </div>
    );
};

export default Users;